import { ReactComponent as Icon } from "components/common/Icons/Progress/Pie/HalfYellow/icon.svg";
interface Props {}

const HalfYellow = (_: Props) => {
  return <Icon />;
};

export default HalfYellow;
